import { useEffect, useState } from "react";
import CountUp from "./countUp";

// ActivityStrip.jsx
const ActivityStrip = ({ stats }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);
  return (
    <div
      className="
        rounded-3xl p-6
        bg-gradient-to-r from-cyan-700 via-blue-600 to-cyan-700
        text-white
        shadow-2xl
        border border-cyan-900
      "
    >
      <div className="flex flex-wrap lg:flex-nowrap items-center justify-between gap-6">
        {stats.map((item, index) => (
          <div
          
            key={item.label}
            className="
              flex-1 min-w-[120px]
              transition-all duration-300
              hover:scale-105
            "
          >
            <p className="text-xs uppercase tracking-widest text-cyan-200">
              {item.label}
            </p>

            <h4 className="text-5xl font-bold mt-1 flex items-center gap-3">
              {item.icon && (
                <div className="p-3 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 group-hover:rotate-6 transition-all duration-500">
                  <div className={`${item?.spin && "animate-spin"}`}> {item.icon}</div>
                </div>
              )}
              <CountUp value={item.value} duration={1200} />
            </h4>

            {/* Divider (except last item) */}
            {index !== stats.length - 1 && (
              <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-10 w-px bg-indigo-400/40"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityStrip;
